<template lang="html">

  <section class="setup">
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Welcome!</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">Contact Info</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">Terms & Agreement</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 4" step="4">Trip ID</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 5" step="5">Complete!</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
                  class="mb-5"
                  color=""
                  height="200px"
          >
            <h1>Welcome to Group Travel Planners!</h1>
            <br/>
            <p>Thanks for registering! We just need a little more information to get started</p>
            <p>Follow the steps to complete registration.</p>
          </v-card>


            <v-btn color="secondary" dark @click="logout()" >Logout</v-btn>
          <v-btn
                  color="primary"
                  @click="e1++"
          >
            Get Started!
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">

          <h3>Account Contact Info</h3>
          <br>

          <v-card
                  class="mb-5"
                  color="grey lighten-1"
                  height="100%"
          >
            <v-form>
              <v-container>
                <v-layout row wrap>

                  <v-flex xs12 sm6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="$userData.firstName"
                            label="First Name"
                            required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="$userData.lastName"
                            label="Last Name"
                            required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>

                  <v-flex xs12 sm6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="$userData.email"
                            label="Email (used for notifications and password reset)"
                            required
                            disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="$userData.phone"
                            label="Phone Number"
                            required
                    ></v-text-field>
                  </v-flex>
                </v-layout>



              </v-container>
            </v-form>
          </v-card>

          <v-btn @click="e1--" flat>Previous</v-btn>

          <v-btn :disabled = "$userData.firstName.length < 2 || $userData.lastName.length < 2  || $userData.phone.length < 9"
                 color="primary"
                 @click="saveContactInfo"
          >
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
            <v-container>

              <sign-document formid="SIlociNJovwKUyxR" redirect="false" v-on:signresult="(result, message) => {this.AgreedTerms = result; if(result == true){this.e1++;}}">

              </sign-document>
              <hr/>
              <br/>
              <v-btn @click="e1--"  color="secondary">Previous</v-btn>
            </v-container>

        </v-stepper-content>



        <v-stepper-content step="4">

          <h3>Enter your Trip ID to complete setup</h3>
          <br>

          <v-card
                  class="mb-5"
                  color="grey lighten-1"
                  height="100px"
          >
            <v-form>
              <v-container>
                <v-layout row wrap>

                  <v-flex xs12 sm5>
                    <v-text-field
                            v-validate="'required'"
                            v-model="tripID"
                            @change="lookupTripInfo"
                            label="Trip ID"
                            required
                    ></v-text-field>

                  </v-flex>
                  <v-flex xs12 sm7>
                    <div style="text-align: left">
                      <p v-if="tripLookup != null">
                        <b>Trip ID: </b> {{tripLookup.tripID}}
                        <br/>
                        <b>Trip Name: </b> {{tripLookup.tripName}}
                        <br/>
                        <b>Departure Date: </b> {{tripLookup.departDate}}</p>
                      <p v-else>Please enter the Trip ID provided to you by the trip director<br>
                        A valid trip ID is required to proceed
                      </p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card>


          <v-btn
                  :disabled = "tripLookup == null"
                  color="primary"
                  @click="completeSetup"
          >
            Complete
          </v-btn>

        </v-stepper-content>
        <v-stepper-content step="5">

          <h1>Account Registration Complete</h1>
          <br/>
          <p>Please add all tour participants related to this account (including yourself if you are traveling with the group).</p>
          <p>*Additional tour participants may be added at a later date if necessary*</p>
          <p>Would you like to do that now?</p>

          <v-btn
                  color="secondary" dark
                  @click="$router.push('/')"
          >
            I will do this later
          </v-btn>
          <v-btn @click="$router.push('/AddTraveler')"
                 color="primary"
          >
            Add a traveler now
          </v-btn>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>

</template>

<script lang="js">
    import signDocument from '../components/SignDocument'
  export default  {
    name: 'setup',
    props: [],
      components: {
          signDocument: signDocument
      },
      mounted() {

        if(this.$userData.tripIDInvite != undefined && !this.$userData.setup) {
            this.tripID = this.$userData.tripIDInvite
        } else if (this.$cookies.isKey("tripToAdd")) {
            this.tripID = this.$cookies.get("tripToAdd");
        }
          console.log('mounted profile', this.$feathers.get('user'))

          this.$userData.firstName = this.$feathers.get('user').firstName
          this.$userData.lastName = this.$feathers.get('user').lastName
          this.$userData.phone = this.$feathers.get('user').phone
          this.$userData.email = this.$feathers.get('user').email
          //this.userData.billingAddress = this.$feathers.get('user').billingAddress

      },
    data() {
      return {
          e1: 0,
          tripID: '',
          tripLookup: null,
          AgreedTerms: false
      }
    },
    methods: {
        logout() {
            this.$feathers.logout();
            this.$cookies.remove("tripToAdd");
            setTimeout(window.location.reload(), 500);
        },
        saveContactInfo () {
            var vueThis = this;
            // vueThis.e1++
            //return;
            this.$services.users.patch(this.$feathers.get('user')._id, {
                "firstName" : vueThis.$userData.firstName,
                "lastName" : vueThis.$userData.lastName,
                "phone" : vueThis.$userData.phone,
            }).then((test) => {
                console.log('updated', test)

                vueThis.e1++
            }).catch(function(error){
                console.error('Error!', error);
            });
        },
        completeSetup () {
          var vueThis = this;
          var currentTrips = []
          if (vueThis.$userData.trips != null || vueThis.$userData.trips != undefined) {
            console.log('testing', vueThis.$userData.trips)
           // currentTrips = vueThis.$userData.trips
          }
          console.log('current trips', currentTrips.push('' + vueThis.tripLookup._id))

           // vueThis.e1++
            //return;
            this.$services.users.patch(this.$feathers.get('user')._id, {
                "trips": ['' + vueThis.tripLookup._id],
                "setup" : true,
                "firstName" : vueThis.$userData.firstName,
                "lastName" : vueThis.$userData.lastName,
                "phone" : vueThis.$userData.phone,
                "billingAddress": {}
            }).then((test) => {
                console.log('updated', test)

                vueThis.$userData.setup = true
                vueThis.$cookies.remove("tripToAdd");
                vueThis.e1++

            }).catch(function(error){
                console.error('Error!', error);
            });
        },
        lookupTripInfo() {
            var vueThis = this;
            this.$services.trips.find({ query: {
                    $limit: 1,
                    tripID: "" + vueThis.tripID
                }
            }).then((result) => {
                console.log('trip look', result.data)
                if(result.data.length > 0 && !result.data[0].disabled)
                    vueThis.tripLookup = result.data[0]
                else
                    vueThis.tripLookup = null
            })
        }

    },
      watch: {
          tripID: function() {
              console.log(this.name)
              this.lookupTripInfo()
          }
      },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .setup {

  }
</style>
